// ============================================
// 6. Updated Sidebar.js - Complete Navigation
// ============================================

import React from 'react';

const Sidebar = ({ currentPage, setCurrentPage }) => {
  const navigationItems = [
    { id: 'dashboard', name: 'Dashboard', icon: '📊' },
    { id: 'government', name: 'Government Intel', icon: '🏛️' },
    { id: 'watchlist', name: 'Watchlist', icon: '👀' },
    { id: 'trades', name: 'Open Trades', icon: '📈' },
    { id: 'completed', name: 'Completed Trades', icon: '📋' },
    { id: 'analysis', name: 'Trade Analysis', icon: '🔬' },
    { id: 'analytics', name: 'Portfolio Analytics', icon: '📊' },
    { id: 'operations', name: 'Operations', icon: '⚙️' },
    { id: 'settings', name: 'Settings', icon: '🔧' }
  ];

  return (
    <div style={{
      backgroundColor: '#2774AE',
      width: '250px',
      minHeight: '100vh',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* FASTWATER CAPITAL LOGO */}
      <div style={{
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        {/* Real Logo from Public Folder */}
        <div style={{
          marginBottom: '16px'
        }}>
          <img 
            src="/fastwater-logo-white.png"
            alt="Fastwater Capital Logo"
            style={{
              width: '200px',
              height: 'auto',
              maxHeight: '142px',
              objectFit: 'contain'
            }}
          />
        </div>
        
        {/* Company Tagline Only */}
        <div>
          <p style={{
            fontFamily: 'Georgia, serif',
            fontSize: '14px',
            fontStyle: 'italic',
            color: '#D4AF37',
            margin: '0',
            textAlign: 'center',
            fontWeight: '600'
          }}>
            Elite Trading System
          </p>
        </div>
      </div>

      {/* Online Status */}
      <div style={{
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#10B981',
          padding: '6px 12px',
          borderRadius: '20px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            animation: 'pulse 2s infinite'
          }}></div>
          <span style={{
            fontFamily: 'Georgia, serif',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: '600'
          }}>Online</span>
          <span style={{
            fontFamily: 'Georgia, serif',
            color: '#ffffff',
            fontSize: '10px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            padding: '2px 6px',
            borderRadius: '8px'
          }}>LIVE</span>
        </div>
      </div>

      {/* Navigation Links - WITH ICONS */}
      <nav style={{ flex: 1 }}>
        <ul style={{
          listStyle: 'none',
          padding: '0',
          margin: '0',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
          {navigationItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => setCurrentPage(item.id)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  borderRadius: '6px',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontFamily: 'Georgia, serif',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  backgroundColor: currentPage === item.id ? '#D4AF37' : 'transparent',
                  color: currentPage === item.id ? '#202A44' : '#ffffff',
                  boxShadow: currentPage === item.id ? '0 2px 8px rgba(212, 175, 55, 0.3)' : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  if (currentPage !== item.id) {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentPage !== item.id) {
                    e.target.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <span>{item.icon}</span>
                <span>{item.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer Info */}
      <div style={{
        marginTop: '24px',
        textAlign: 'center',
        fontFamily: 'Georgia, serif'
      }}>
        <div style={{
          fontSize: '10px',
          color: '#ffffff',
          marginBottom: '8px'
        }}>
          <div style={{
            color: '#D4AF37',
            fontWeight: '600',
            marginBottom: '2px'
          }}>
            Last Sync:
          </div>
          <div>{new Date().toLocaleTimeString()}</div>
        </div>
        <div style={{
          fontSize: '10px',
          color: '#ffffff',
          opacity: '0.7',
          fontStyle: 'italic'
        }}>
          Building Generational Wealth
        </div>
      </div>
    </div>
  );
};

export default Sidebar;